import React from 'react';
export function Footer() {
  return <footer className="py-8 px-6 border-t border-zinc-900 text-center" data-id="element-24">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-zinc-600" data-id="element-25">
        <p data-id="element-26">© {new Date().getFullYear()} danceforfans.com</p>
        <div className="flex items-center gap-4" data-id="element-27">
          <span data-id="element-28">Concept in progress</span>
          <span className="w-1 h-1 rounded-full bg-zinc-800" data-id="element-29" />
          <a href="tel:+13058779092" className="hover:text-zinc-400 transition-colors" data-id="element-30">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}